import React from "react";
import { brandLogo, brandColors, brandFontUrl } from "../brand/theme";
import FallbackLogo from "../images/Logo6.png";
import "../containers/reservations.css";
import "./ReservePageLayout.css";

/**
 * Full-page layout for /reserve routes: brand header (logo + logout), no app navbar.
 * Logo: Bedrock Slate wordmark from brand. Font: Normalidad from brand/BrandFont.
 * Colors: graystone, limestone, beacon yellow, bedrock slate.
 */
export default function ReservePageLayout({ children, handleLogout }) {
  const brandVars = {
    "--brand-primary": brandColors.primary,
    "--brand-primary-hover": brandColors.primaryHover,
    "--brand-graystone": brandColors.graystone,
    "--brand-limestone": brandColors.limestone,
    "--brand-white": brandColors.white,
    "--brand-border": brandColors.border,
    "--brand-success": brandColors.success,
    "--brand-on-primary": brandColors.onPrimary,
    "--brand-beacon-yellow": brandColors.beaconYellow,
    "--brand-bedrock-slate": brandColors.bedrockSlate,
  };

  const fontFaceCss = `@font-face{font-family:'Normalidad';src:url('${brandFontUrl}') format('opentype');font-weight:100 900;font-display:swap;}`;

  return (
    <div className="reservation-page reservation-page--brand" style={brandVars}>
      <style dangerouslySetInnerHTML={{ __html: fontFaceCss }} />
      <header className="reservation-brand-header">
        <img
          src={brandLogo}
          alt="Bedrock Wireless"
          className="reservation-brand-logo"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = FallbackLogo;
          }}
        />
        {handleLogout && (
          <button
            type="button"
            onClick={handleLogout}
            className="reservation-logout-btn"
          >
            Logout
          </button>
        )}
      </header>
      <div className="reservation-container">{children}</div>
    </div>
  );
}
